import { __extends } from "tslib";
import color from "color";
import * as React from "react";
import { View, StyleSheet } from "react-native";
import Icon from "../Icon";
import TouchableRipple from "../TouchableRipple";
import PnmacText from "../Typography/PnmacText";
import defaultTheme from "../styles/defaultTheme";
import { black, white } from "../styles/colors";
import { textStyle } from '../v2/theme';
var PnmacMenuItem = /** @class */function (_super) {
  __extends(PnmacMenuItem, _super);
  function PnmacMenuItem() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  PnmacMenuItem.prototype.render = function () {
    var _a = this.props,
      icon = _a.icon,
      title = _a.title,
      subtitle = _a.subtitle,
      disabled = _a.disabled,
      onPress = _a.onPress,
      theme = _a.theme,
      style = _a.style,
      testID = _a.testID,
      titleStyle = _a.titleStyle;
    var disabledColor = color(black).alpha(0.32).rgb().string();
    var titleColor = disabled ? disabledColor : color("#003087").alpha(0.87).rgb().string();
    var iconColor = disabled ? disabledColor : color("#003087").alpha(0.54).rgb().string();
    return /*#__PURE__*/React.createElement(TouchableRipple, {
      style: [styles.container, style],
      onPress: onPress,
      disabled: disabled,
      testID: testID
    }, /*#__PURE__*/React.createElement(View, {
      style: styles.row
    }, icon ? (/*#__PURE__*/React.createElement(View, {
      style: [styles.item, styles.icon],
      pointerEvents: "box-none"
    }, /*#__PURE__*/React.createElement(Icon, {
      source: icon,
      size: 24,
      color: iconColor
    }))) : null, /*#__PURE__*/React.createElement(View, {
      style: [styles.item, styles.content, icon ? styles.widthWithIcon : null],
      pointerEvents: "none"
    }, /*#__PURE__*/React.createElement(PnmacText, {
      numberOfLines: 1,
      style: [textStyle.loanSelector, {
        color: titleColor
      }, titleStyle]
    }, title), subtitle ? /*#__PURE__*/React.createElement(PnmacText, {
      style: textStyle.loanSelector
    }, subtitle) : "")));
  };
  PnmacMenuItem.displayName = "Menu.Item";
  return PnmacMenuItem;
}(React.Component);
var minWidth = 112;
var maxWidth = 280;
var iconWidth = 40;
var styles = StyleSheet.create({
  container: {
    paddingHorizontal: 8,
    minWidth: minWidth,
    maxWidth: maxWidth,
    height: 48,
    justifyContent: "center"
  },
  row: {
    flexDirection: "row"
  },
  icon: {
    width: iconWidth
  },
  title: {
    fontSize: 16
  },
  item: {
    marginHorizontal: 8
  },
  content: {
    justifyContent: "center",
    minWidth: minWidth - 16,
    maxWidth: maxWidth - 16
  },
  widthWithIcon: {
    maxWidth: maxWidth - (iconWidth + 48)
  }
});
export default defaultTheme(PnmacMenuItem);
export { PnmacMenuItem };